(function () {
  'use strict';

  var wrapper, steps, totalSteps, currentStep, score, formBlock;

  function init() {
    wrapper = document.querySelector('.cn-hoffmann-quiz');
    if (!wrapper) return;

    var stepsWrap = wrapper.querySelector('.jhq-steps-wrap');
    if (!stepsWrap) return;

    // Randomise step order in DOM before binding
    var stepArr = Array.prototype.slice.call(stepsWrap.querySelectorAll('.jhq-step'));
    stepArr.sort(function () { return Math.random() - 0.5; });
    for (var k = 0; k < stepArr.length; k++) {
      stepsWrap.appendChild(stepArr[k]);
    }

    steps = wrapper.querySelectorAll('.jhq-step');
    totalSteps = steps.length;
    if (totalSteps === 0) return;

    currentStep = 0;
    score = 0;
    formBlock = wrapper.querySelector('.form-quiz-block');

    // Sync totals in both nav bars
    var totalEls = wrapper.querySelectorAll('.jhq-total');
    for (var t = 0; t < totalEls.length; t++) {
      totalEls[t].textContent = totalSteps;
    }

    showStep(0);

    // Start screen button
    var startBtn = wrapper.querySelector('.jhq-start__btn');
    if (startBtn) {
      startBtn.addEventListener('click', function (e) {
        e.preventDefault();
        wrapper.querySelector('.jhq-start').style.display = 'none';
        wrapper.querySelector('.jhq-form').style.display = 'block';
      });
    }

    // Next buttons (top + bottom navbars)
    var nextBtns = wrapper.querySelectorAll('.jhq-next-btn');
    for (var n = 0; n < nextBtns.length; n++) {
      nextBtns[n].addEventListener('click', function (e) {
        e.preventDefault();
        if (!this.classList.contains('disabled') && currentStep < totalSteps - 1) {
          currentStep++;
          showStep(currentStep);
          if (window.innerWidth <= 749 && formBlock) {
            formBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }

    // Submit buttons (top + bottom navbars)
    var submitBtns = wrapper.querySelectorAll('.jhq-submit-btn');
    for (var s = 0; s < submitBtns.length; s++) {
      submitBtns[s].addEventListener('click', function (e) {
        e.preventDefault();
        if (!this.classList.contains('disabled')) {
          handleSubmit();
        }
      });
    }

    // Bind radio inputs for all steps
    for (var i = 0; i < steps.length; i++) {
      bindRadios(steps[i]);
    }
  }

  function bindRadios(step) {
    var radios = step.querySelectorAll('.jhq-radio-input');
    for (var j = 0; j < radios.length; j++) {
      radios[j].addEventListener('change', function (e) {
        onAnswerChange(e, step);
      });
    }
  }

  function showStep(n) {
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('is-active');
    }
    steps[n].classList.add('is-active');
    updateNav();
  }

  function updateNav() {
    var answered = steps[currentStep].dataset.answered === 'true';
    var isLast = currentStep === totalSteps - 1;

    var nextBtns = wrapper.querySelectorAll('.jhq-next-btn');
    for (var n = 0; n < nextBtns.length; n++) {
      nextBtns[n].style.display = isLast ? 'none' : '';
      if (answered) {
        nextBtns[n].classList.remove('disabled');
      } else {
        nextBtns[n].classList.add('disabled');
      }
    }

    var submitBtns = wrapper.querySelectorAll('.jhq-submit-btn');
    for (var s = 0; s < submitBtns.length; s++) {
      submitBtns[s].style.display = isLast ? '' : 'none';
      if (answered) {
        submitBtns[s].classList.remove('disabled');
      } else {
        submitBtns[s].classList.add('disabled');
      }
    }
  }

  function onAnswerChange(e, step) {
    if (step.dataset.answered === 'true') return;

    var selectedLabel = e.target.closest('.jhq-radio-item');
    if (!selectedLabel) return;

    var isCorrect = selectedLabel.dataset.correct === 'true';

    // Disable all radios in this step
    var radios = step.querySelectorAll('.jhq-radio-input');
    for (var r = 0; r < radios.length; r++) {
      radios[r].disabled = true;
    }

    // Highlight correct answer; mark wrong if selected was incorrect
    var items = step.querySelectorAll('.jhq-radio-item');
    for (var j = 0; j < items.length; j++) {
      if (items[j].dataset.correct === 'true') {
        items[j].classList.add('right');
      }
    }
    if (!isCorrect) {
      selectedLabel.classList.add('wrong');
    } else {
      score++;
    }

    // Flip the card
    var flipInner = step.querySelector('.flip-card-inner');
    if (flipInner) {
      flipInner.classList.add('show');
    }

    // Count answered steps
    var answeredCount = 0;
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].dataset.answered === 'true') answeredCount++;
    }
    answeredCount++; // include the one we just answered (dataset not yet set)

    // Update answered count + progress bar in both navbars
    var answeredEls = wrapper.querySelectorAll('.jhq-answered');
    for (var a = 0; a < answeredEls.length; a++) {
      answeredEls[a].textContent = answeredCount;
    }
    var bars = wrapper.querySelectorAll('.jhq-progress-bar');
    for (var b = 0; b < bars.length; b++) {
      bars[b].style.width = (answeredCount / totalSteps * 100) + '%';
    }

    step.dataset.answered = 'true';
    updateNav();

    if (window.innerWidth <= 749 && formBlock) {
      formBlock.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  function handleSubmit() {
    var scoreBoard = wrapper.querySelector('.jhq-score-board');
    if (scoreBoard) {
      scoreBoard.textContent = 'You got ' + score + ' out of ' + totalSteps + ' quotes right.';
    }
    wrapper.querySelector('.jhq-form').style.display = 'none';
    wrapper.querySelector('.jhq-score-screen').style.display = 'block';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
